<template>
  <div>
    <router-view/>
    <!-- Popup per installazione su sistemi apple -->
    <b-alert
      id="appleInstallPopup"
      v-model="popup_show"
      class="position-fixed fixed-bottom m-0 rounded-0"
      dismissible
    >
      <b-row>
        <b-col cols="3" md="1" class="text-center">
          <b-img :src="wbit_icon_path" fluid alt="wbit icon"></b-img>
        </b-col>
        <b-col class="mt-2 text-justify">
          Installa la Web App sul tuo dispositivo: tocca <b-img class="ml-2 mr-2" :src="apple_share_icon" fluid alt="apple share icon"></b-img>
          poi <span style="font-weight:600">Aggiungi a Home</span> <b-img class="ml-1" :src="apple_add_home_icon" fluid alt="apple add home icon"></b-img>
        </b-col>
      </b-row>
    </b-alert>
  </div>
</template>

<script>
import { generalLib } from '@/generalLib'

export default {
  name: 'App',
  data () {
    return {
      // Flag per visualizzazione popup installazione su apple.
      popup_show : false,
      // Le due icone da piazzare nel popup e quello del'icona welfarebit presa
      // dalla cartella delle icone della pwa in public.
      apple_add_home_icon : require('@/assets/icons/apple_add_home_icon.png'),
      apple_share_icon : require('@/assets/icons/apple_share_icon.png'),
      wbit_icon_path : process.env.BASE_URL + 'img/icons/apple-touch-icon-60x60.png'
    }
  },
  /**
   * Dopo un secondo se siamo su un sistema apple e non sto facendo partire
   * la app dal link nella home propone il popup di installazione.
   */
  mounted : function () {
    setTimeout( () => {
      if ( generalLib.isIos() && !generalLib.isIosStandalone() ) {
        this.popup_show = true;
      }
    }, 1000 );
  }
}
</script>

<style scoped>
#appleInstallPopup {
  background: #ffffff;
  border-color: #ffffff;
  color: #000000;
  z-index: 2000;
}
</style>
